import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {ITableColumn} from '../../../../shared/shared/table/table-column';
import {ITableDataItem} from '../../../../shared/shared/table/table-data-item';
import {IGenerateActivityFormData} from './ai-generate-activity/ai-generate-activity.component';
import {ICardColumn, IMatchRowItem, IUploadMapping} from './steps/match-columns-step/match-columns-step.component';
import {IImportResponseDTO, IImportStatistics, IPreviewPDFImportResponseDTO} from './upload-files.service';

export const IStepOrderServiceToken = new InjectionToken<IStepOrderService>('IStepOrderServiceToken');

export interface IStepOrderService {
    importCSVResponse$:Observable<IImportResponseDTO>;
    currentStep$: Observable<number>;
    stepLoading$: Observable<boolean>;
    previewColumns$: Observable<ITableColumn[]>;
    previewData$: Observable<ITableDataItem[]>;
    invalidData$:Observable<ITableDataItem[]>;
    importStats$:Observable<IImportStatistics>;
    failedImports$: Observable<{ contract_card: null; filename: string; id: number }[]>;
    rowItems$: Observable<IMatchRowItem[]>;
    cardColumns$: Observable<ICardColumn[]>;
    mappings$: Observable<IUploadMapping[]>;
    first_line_titles: 0 | 1;
    mergeOrganisations:boolean;
    importId: number;
    importSettings: IGenerateActivityFormData;
    CSVImportSkipped: boolean;
    documentTypeId: number;
    pdfImportSummary: IPreviewPDFImportResponseDTO;
    importInProgress$: Observable<boolean>;
    importCompleted$: Observable<boolean>;

    next(): void;
    previous(): void;
    moveToStep(step: number): void;
    fetchFirstRow(importId: number): void
    fetchPotentialMappings(): void;
    reset(): void;
    onMappingChange(mappings): void;
    setImportCSVResponse(stats: IImportResponseDTO):void;
    setImportInProgress(value: boolean): void;
    setImportCompleted(value: boolean): void;
    init():void;
}
